// Color palette sourced from public/logo/logo_l.png (warm gold/peach circle,
// near-black octopus silhouette).
const theme = {
  colors: {
    primary: '#1B1B1B',
    primaryHover: '#3A3A3A',
    background: '#F6C878',
    surface: '#FFF8EC',
    text: '#1B1B1B',
    mutedText: '#7A6A50',
    error: '#B3261E',
    border: '#E4B36B',
  },
};

export type AppTheme = typeof theme;

export {
  theme,
};
